import { combineReducers } from "@reduxjs/toolkit";
import store from "./storeSlice";

const settingsReducers = combineReducers({
	store,
});

export default settingsReducers;
